import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { post } from "../../utils/apiManager";
import { toast } from "react-toastify";
import { baseURL } from "../../config/config";
import Editor from "../../components/Editor";

const inputS = (err) => ({ width: '100%', padding: '10px 14px', borderRadius: 8, border: `1.5px solid ${err ? '#AD2429' : '#e2e8f0'}`, fontSize: 14, color: '#0a1628', background: '#fff', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' });

const Add = () => {
  const { register, handleSubmit, formState: { errors }, setValue, watch } = useForm();
  const Navigate = useNavigate();
  const [editorData, setEditorData] = useState('');
  const [loading, setLoading] = useState(false);
  const isModified = watch("isModified");

  useEffect(() => {
    if (isModified === "true" || isModified === true) setValue("isCompany", true);
  }, [isModified]);

  const onSubmit = (data) => {
    setLoading(true);
    post(`${baseURL}/email-template`, { ...data, description: editorData })
      .then((res) => { setLoading(false); if (res?.status) Navigate("/admin/email"); else toast.error(res?.message); })
      .catch((err) => { setLoading(false); toast.error(err?.response?.data?.error); });
  };

  const checkBox = (id, label, regName, disabled = false) => (
    <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: disabled ? 'not-allowed' : 'pointer', padding: '8px 12px', borderRadius: 8, border: '1px solid #edf0f7', background: '#fafbfd', fontSize: 13, color: '#3a4a6a', opacity: disabled ? 0.5 : 1 }}>
      <input type="checkbox" value={true} id={id} disabled={disabled} style={{ accentColor: '#AD2429' }} {...register(regName)} />
      {label}
    </label>
  );

  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #edf0f7', boxShadow: '0 1px 4px rgba(26,39,68,.05)', overflow: 'hidden' }}>
        <div style={{ padding: '18px 28px', borderBottom: '1px solid #edf0f7', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: 0 }}>Add Email Template</h3>
            <p style={{ fontSize: 13, color: '#9aa5c0', margin: '3px 0 0' }}>Create a new notification email template</p>
          </div>
          <button onClick={() => Navigate('/admin/email')} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>← Back</button>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} style={{ padding: '28px' }}>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginBottom: 20 }}>
            <div>
              <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'flex', gap: 4 }}>Title <span style={{ color: '#AD2429' }}>*</span></label>
              <input placeholder="Template title" type="text" style={inputS(errors.title)} {...register("title", { required: true })} />
              {errors.title && <span style={{ fontSize: 12, color: '#AD2429', marginTop: 4, display: 'block' }}>Required</span>}
            </div>
            <div>
              <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'flex', gap: 4 }}>Subject <span style={{ color: '#AD2429' }}>*</span></label>
              <input placeholder="Email subject line" type="text" style={inputS(errors.subject)} {...register("subject", { required: true })} />
              {errors.subject && <span style={{ fontSize: 12, color: '#AD2429', marginTop: 4, display: 'block' }}>Required</span>}
            </div>
            <div>
              <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'block' }}>By Whom</label>
              <select style={{ ...inputS(false), appearance: 'none' }} {...register("type")}>
                <option value="">Select</option>
                <option value="company">Company</option>
                <option value="super admin">Super Admin</option>
                <option value="automatic">Automatic</option>
              </select>
            </div>
            <div>
              <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'block' }}>When Sent</label>
              <input type="datetime-local" style={inputS(false)} {...register("dateTime")} />
            </div>
          </div>

          <div style={{ marginBottom: 20 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 8, display: 'block' }}>Email Body</label>
            <div style={{ border: '1.5px solid #e2e8f0', borderRadius: 8, overflow: 'hidden' }}>
              <Editor editorData={editorData} setEditorData={setEditorData} />
            </div>
          </div>

          <div style={{ display: 'flex', gap: 12, marginBottom: 24 }}>
            {checkBox("company", "Company", "isCompany", !!isModified)}
            {checkBox("self", "Self", "isSelf")}
            {checkBox("modified", "Modified", "isModified")}
          </div>

          <div style={{ paddingTop: 16, borderTop: '1px solid #edf0f7', display: 'flex', gap: 12 }}>
            <button type="submit" disabled={loading} style={{ background: '#AD2429', color: '#fff', border: 'none', borderRadius: 8, padding: '11px 28px', fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit', opacity: loading ? 0.7 : 1 }}>
              {loading ? 'Saving...' : 'Create Template'}
            </button>
            <button type="button" onClick={() => Navigate('/admin/email')} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '11px 22px', fontSize: 15, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Add;
